<template>
  <div class="px-1 mb-5">
    <div class="flex items-center justify-between mb-8">
      <h3 class="H600">{{ $t("Overview".getTranslationKey()) }}</h3>
      <app-primary-button
        v-if="!shouldDisableInput && !isAllBalanceInfoData?.locked_month_details?.is_locked"
        :buttonLabel="$t('Add Expense'.getTranslationKey())"
        @click="addNewExpense()"
      >
        <template #icon> <v-icon icon="mdi-plus"></v-icon> </template
      ></app-primary-button>
    </div>
    <div class="w-full bg-white rounded-md border border-gray-200 grid grid-cols-4">
      <div class="border-r border-gray-200 px-4 py-2 border-b font-semibold">{{$t("Title".getTranslationKey())}}</div>
      <div class="col-span-3 border-b px-4 py-2">{{projectDetails?.project_name || "-"}}</div>
      <div class="border-r border-gray-200 px-4 py-2 border-b font-semibold">{{$t("Project Office".getTranslationKey())}}</div>
      <div class="col-span-3 border-b px-4 py-2">{{projectDetails?.project_office_location}} ({{projectDetails?.project_start_date?.formattedDate() || "-"}} - {{projectDetails?.project_end_date?.formattedDate() || "-"}})</div>
      <div class="border-r border-gray-200 px-4 py-2 border-b font-semibold">{{$t("Local financial-controller".getTranslationKey())}}</div>
      <div class="col-span-3 border-b px-4 py-2">{{projectDetails?.controller_first_name || "-"}} {{projectDetails?.controller_last_name || "-"}}</div>
      <div class="border-r border-gray-200 px-4 py-2 font-semibold">{{$t("Transfer to the local office".getTranslationKey())}}</div>
      <div class="col-span-3 px-4 py-2">{{projectDetails?.currency || "-"}}</div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { formatDate } from "@/services/helpers";

export default defineComponent({
  name: "OverviewHeading",
  components: {},
  props: {
    selectedCurrency: String,
  },
  data() {
    return {
      currencies: null,
    };
  },
  computed: {
    canEditPmLocalModule() {
      return this.$store.state.auth.canEditModuleSections;
    },
    isEditButton() {
      return this.$store.getters["hrResources/isEditButton"] && this.canEditPmLocalModule?.includes("Project Overview")
    },
    isEditPmLocal() {
      return this.$store.getters["hrResources/isEditEmployee"];
    },
    currentPath() {
      return this.$route.path;
    },
    shouldDisableInput() {
      // Add your condition to disable the input element here
      return (
        this.currentPath === "/edit-pm-local" &&
        this.isEditPmLocal &&
        !this.isEditButton
      );
    },
    projectDetails() {
      return this.$store.getters["projectOverview/isProjectDetails"];
    }
 
    
  },
  methods: {
    addNewExpense() {
      this.$store.commit("projectOverview/SET_ADD_EXPENSE_TO_STATE", true);
      this.$store.commit("commonResources/SET_CURRENT_TAB_TO_STATE", 1);
    },
    formattedDate(date) {
      return formatDate(date);
    },
  },
});
</script>
